<template>
  <v-card>
    <v-skeleton-loader
      v-if="companyDetailsLoading"
      class="skeleton-loader"
      type="table-heading, article"></v-skeleton-loader>
    <template v-else>
      <div class="d-flex">
        <div class="d-flex align-center">
          <div class="d-flex flex-column">
            <v-card-title>{{ $t("settings.billing.company_details.title") }}</v-card-title>
            <v-card-subtitle>{{ $t("settings.billing.company_details.subtitle") }}</v-card-subtitle>
          </div>
        </div>
        <v-card-actions class="ml-auto">
          <v-btn :loading="formLoading" @click="saveCompanyDetails" class="add-payment-btn" outlined :color="'primary'">
            {{ $t("settings.billing.company_details.save") }}
          </v-btn>
        </v-card-actions>
      </div>

      <v-form class="company-details-form" ref="clientForm">
        <v-row>
          <v-col>
            <template v-if="companyFormData.company">
              <va-text-input
                class="spacing-bottom--16"
                v-model="companyFormData.name"
                :label="$t('settings.billing.company_details.company_name_label')"
                required
                :placeholder="$t('settings.billing.company_details.company_name_placeholder')"></va-text-input>
            </template>
            <template v-else>
              <va-text-input
                class="spacing-bottom--16"
                v-model="companyFormData.name"
                :label="$t('settings.billing.company_details.name_label')"
                required
                :placeholder="$t('settings.billing.company_details.name_placeholder')"></va-text-input>
            </template>
            <va-text-input
              class="spacing-bottom--16"
              v-model="companyFormData.line1"
              required
              :label="$t('settings.billing.company_details.company_address_label')"
              :placeholder="$t('settings.billing.company_details.company_address_placeholder')"></va-text-input>
            <va-text-input
              class="spacing-bottom--16"
              v-model="companyFormData.city"
              required
              :label="$t('settings.billing.company_details.company_city_label')"
              :placeholder="$t('settings.billing.company_details.company_city_placeholder')"></va-text-input>
            <va-autocomplete-input
              v-model="companyFormData.country"
              required
              :label="$t('settings.billing.company_details.company_country_label')"
              :choices="countries"
              cache-items
              :placeholder="$t('settings.billing.company_details.company_country_placeholder')"></va-autocomplete-input>
          </v-col>
          <v-col>
            <va-text-input
              class="spacing-bottom--16"
              v-model="companyFormData.taxId"
              :label="$t('settings.billing.company_details.company_tax_id_label')"
              :placeholder="$t('settings.billing.company_details.company_tax_id_placeholder')"></va-text-input>
            <va-text-input
              class="spacing-bottom--16"
              v-model="companyFormData.line2"
              :label="$t('settings.billing.company_details.company_address_2_label')"
              :placeholder="$t('settings.billing.company_details.company_address_2_placeholder')"></va-text-input>
            <va-text-input
              class="spacing-bottom--16"
              v-model="companyFormData.state"
              :label="$t('settings.billing.company_details.company_state_label')"
              :placeholder="$t('settings.billing.company_details.company_state_placeholder')"></va-text-input>
            <va-text-input
              class="spacing-bottom--16"
              v-model="companyFormData.postalCode"
              required
              :label="$t('settings.billing.company_details.company_zipcode_label')"
              :placeholder="$t('settings.billing.company_details.company_zipcode_placeholder')"></va-text-input>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </v-card>
</template>

<script>
  import countries from "@/assets/data/countries";
  import { mapGetters } from "vuex";
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    name: "CompanyDetails",
    data() {
      return {
        countries,
        companyFormData: {},
        formLoading: false,
      };
    },
    computed: {
      ...mapGetters({
        subscription: "billing/getSubscription",
        companyDetails: "billing/getCompanyDetails",
        companyDetailsLoading: "billing/getCompanyDetailsLoading",
      }),
    },
    watch: {
      companyDetails: {
        immediate: true,
        handler(data) {
          if (!data) return;

          this.companyFormData = {
            ...data,
          };
        },
      },
    },
    methods: {
      async saveCompanyDetails() {
        if (!this.$refs.clientForm.validate()) return false;

        try {
          this.formLoading = true;

          await this.$admin.dataProvider.customHttpCall(
            "PUT",
            `subscriptions/${this.subscription.id}/billing_information`,
            this.companyFormData,
          );
          this.$admin.toast.success(this.$t("settings.billing.company_details.updated_successfully"));
        } catch (e) {
          this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
        } finally {
          this.formLoading = false;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .company-details-form {
    .col {
      & > div {
        &:not(:last-of-type) {
          margin-bottom: 16px;
        }
      }
    }
  }
</style>
